<template>
  <card-item card="item_season" :tabs="tabs" :activeTab="activeTab" :id="id" :infoKeys="infoKeys"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
        // {
        //   title: "Четверти",
        //   component: () => import("./SeasonPart"),
        //                  key:'parts',
        // },
      ],
      activeTab: 0,
      infoKeys:[
          {
            key: 'title',
            title:'Учебный сезон'
          },
    ]
    };
  },
};
</script>